export enum PricingCopilotCustomOverviewRankAggregateType {
	STATE = 'STATE',
	UTILITY = 'UTILITY',
}

export class PricingCopilotCustomOverviewRankReport {
	public stateLong: string;
	public utilityName: string;
	public totalBidsSubmitted: number;
	public averageDelta: number;
	public firstPlace: number;
	public secondPlace: number;
	public thirdPlace: number;
	public otherPlace: number;

	constructor(pricingCopilotCustomOverviewRankReport: PricingCopilotCustomOverviewRankReport) {
		Object.assign(this, pricingCopilotCustomOverviewRankReport);
	}
}
